<div class="cabinetwrapper cabinet-detail--container">
  <div class="desktopdevicedetail cabinet-summary  d-flex">
    <div class="d-flex align-items-center cursor-pointer" (click)="goBack()">
      <img class="previewback" src="../../../../assets/images/storelist/backarrow.svg">
    </div>
    <div class="content-block">
      <div class="flex-container gap-3 mb-2 w-max-content position-relative">
        <h3 class="text-heading-3 text-dark text-start" *ngIf="u_name">{{ u_name }}</h3>
        <div class="flex-container justify-content-center px-2 cursor-pointer" id="dots-popup--trigger" (click)="openDotPopup($event)">
          <img class="icon-xs" src="../../../assets/images/three_dots.png" alt="">
        </div>
        <div class="popup" id="dots-popup">
          <ul>
            <li (click)="openDialog(u_name, 'u_name')">Edit Unique Name</li>
          </ul>
        </div>  
      </div>
      <div class="text-heading-5 d-flex align-items-center" *ngIf="lastAccessed">
        <img class="calender-content" src="../../../../assets/images/storelist/calendar.svg">Last accessed at {{ lastAccessed }}
      </div>
    </div>
  </div>  
  
  <div class="table-container">
    <div class="table-top-wrapper">
      <div>
        <h2 class="text-heading-3 text-start mb-1 text-capitalize">Entries: {{ desktopdetail.length }}</h2>
      </div>
      <div class="search-controls">
        <form class="search-block" (submit)="onSearchSubmit()"> 
            <div class="search-input">
                <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by Desktop unique name">
            </div>
            <button type="submit" class="icon-btn">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                </svg>
            </button>
        </form>
                        <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
        <button class="export-btn" (click)="getDesktopDownload(storeId,devicesId)">
            <i class="export-icon"></i>
            Export
        </button>
      </div>
      </div>
      <div class="table-wrapper">
        <table class="table table-responsive">
          <thead class="position-relative">
            <tr>
              <th class="" scope="col">RFID</th>
              <th class="" scope="col">Product name</th>
              <th class="" scope="col">Batch Number</th>
              <th class="" scope="col">Username
                <span (click)="openUsersPopup($event)">
                  <img *ngIf="selectedUserNames.length === 0" class="sort-img" src="../../../../assets/images/dropdown.png" alt="">
                  <img *ngIf="selectedUserNames.length !== 0" class="ms-1" src="../../../assets/images/check.svg" alt="" srcset="">
                </span>
                <div class="popup" id="users-popup">
                    <form>
                        <div class="form-group" *ngFor="let user of userNamesList">
                          <input name="user" [id]="user.first_name" type="checkbox" [value]="user.id" [checked]="selectedUserNames.includes(user.id.toString()) ? true : false" (change)="onUserFilterChange($event)">
                          <label [for]="user.first_name">{{ user.first_name+ " " + user.last_name }}</label>
                        </div>
                    </form> 
                </div> 
              </th>
              <th class="" scope="col">Stock Read at
                <span (click)="raisedAtSort()">
                  <img class="sort-img" src=".../../../../../../assets/images/table/sort.png" alt="">
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let desktop of desktopdetail">
              <td class="text-start">{{ desktop.rfid }}</td>
              <td class="text-start">{{ desktop.product_name }}</td>
              <td class="text-start">{{ desktop.batch_no }}</td>
              <td class="text-start text-capitalize">{{ desktop.username }}</td>
              <td class="text-start">{{ timestampFormat(desktop.stock_read_at, "DD/MM/YYYY, HH:mm:ss") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
  
</div>
